/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_R3Inputs */



/**
* | output |
* | --- |
* | "R3 VP distribution" |
*
* @param {Rounds_R3Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_r3 = /** @type {((inputs?: Rounds_R3Inputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_R3Inputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("R3 Distribution VP")
	if (locale === "es") return /** @type {LocalizedString} */ ("R3 Distribución de VP")
	if (locale === "pt") return /** @type {LocalizedString} */ ("R3 Distribuição VP")
	if (locale === "it") return /** @type {LocalizedString} */ ("R3 Distribuzione VP")
	return /** @type {LocalizedString} */ ("R3 VP distribution")
});